/**
 * Ошибки микрофона на человеческом языке (15.09.2026).
 *
 * Браузер отдаёт их по-английски и без подсказки, что делать: у Тани на кнопке
 * «Позвонить» висело «Requested device not found», и звонок не шёл. Здесь —
 * что случилось и что нажать, словами пульта.
 */
const MISSING_NAMES = new Set(['NotFoundError', 'DevicesNotFoundError', 'OverconstrainedError']);
const DENIED_NAMES = new Set(['NotAllowedError', 'PermissionDeniedError', 'SecurityError']);
const BUSY_NAMES = new Set(['NotReadableError', 'TrackStartError', 'AbortError']);
function nameOf(error) {
    return typeof error === 'object' && error !== null && 'name' in error ? String(error.name) : '';
}
function messageOf(error) {
    return error instanceof Error ? error.message : typeof error === 'string' ? error : '';
}
/** Выбранного микрофона нет: гарнитуру отключили или браузер сменил её id */
export function isMissingDeviceError(error) {
    return (MISSING_NAMES.has(nameOf(error)) ||
        /requested device not found|device not found|overconstrained/i.test(messageOf(error)));
}
/** Текст для диспетчера; null — это не ошибка микрофона, показывать как есть */
export function mediaErrorText(error) {
    if (isMissingDeviceError(error)) {
        return 'Микрофон не найден. Подключите гарнитуру или выберите микрофон в «Микрофон, наушники и громкость» и позвоните ещё раз';
    }
    const name = nameOf(error);
    const message = messageOf(error);
    if (DENIED_NAMES.has(name) || /permission denied|not allowed/i.test(message)) {
        return 'Браузер не дал доступ к микрофону. Нажмите на значок замка слева от адреса сайта, разрешите микрофон и обновите страницу';
    }
    if (BUSY_NAMES.has(name) || /could not start|not readable/i.test(message)) {
        return 'Микрофон не запускается: его занимает другая программа или гарнитура отключилась. Закройте программу со звонками или переподключите гарнитуру';
    }
    return null;
}
/** Ошибку микрофона — в понятную, любую другую — без изменений */
export function asMediaError(error) {
    const text = mediaErrorText(error);
    return text === null ? error : new Error(text);
}
//# sourceMappingURL=media-errors.js.map